import { ClusterAlertState, MonitoringService } from '@qdrant/qdrant-cloud-public-api/monitoring/v1';
import {
  getClusterEvents,
  getClusterInferenceMetrics,
  getClusterLogs,
  getClusterSummaryMetrics,
  getClusterUsageMetrics,
  listClusterAlerts,
} from '@qdrant/qdrant-cloud-public-api/monitoring/v1/connect-query';
import { transport } from '@/api/transport';
import { createServiceQueries, queryOptions } from '@/connect-query';

export const monitoringService = createServiceQueries(MonitoringService, {
  getClusterEventsQuery: (params) =>
    queryOptions(
      getClusterEvents,
      { accountId: params.accountId, clusterId: params.clusterId, since: params.since, until: params.until },
      {
        transport,
        select: (data) => data.items,
      },
    ),
  getClusterInferenceMetricsQuery: (params) =>
    queryOptions(
      getClusterInferenceMetrics,
      {
        accountId: params.accountId,
        clusterId: params.clusterId,
        inferenceModelId: params.inferenceModelId,
        interval: params.interval,
        since: params.since,
        until: params.until,
      },
      {
        transport,
        select: (data) => data.models,
      },
    ),
  getClusterLogsQuery: (params) =>
    queryOptions(
      getClusterLogs,
      { accountId: params.accountId, clusterId: params.clusterId, since: params.since, until: params.until },
      {
        transport,
        select: (data) => data.items,
      },
    ),
  getClusterSummaryMetricsQuery: (params) =>
    queryOptions(
      getClusterSummaryMetrics,
      { accountId: params.accountId, clusterId: params.clusterId },
      {
        transport,
        select: (data) => data.nodes,
      },
    ),
  getClusterUsageMetricsQuery: (params) =>
    queryOptions(
      getClusterUsageMetrics,
      {
        accountId: params.accountId,
        clusterId: params.clusterId,
        aggregator: params.aggregator,
        since: params.since,
        until: params.until,
      },
      {
        transport,
      },
    ),
  listClusterAlertsQuery: (params) =>
    queryOptions(
      listClusterAlerts,
      {
        accountId: params.accountId,
        clusterId: params.clusterId,
        state: ClusterAlertState.FIRING,
      },
      {
        transport,
        select: (data) => data.alerts,
      },
    ),
});
